import { CommonModule } from '@angular/common';
import {
    CUSTOM_ELEMENTS_SCHEMA,
    ChangeDetectionStrategy,
    Component,
    ContentChild,
    EventEmitter,
    Input,
    OnInit,
    Output,
    TemplateRef,
} from '@angular/core';
import { BazaNcBootstrapDto } from '@scaliolabs/baza-nc-shared';
import { BazaWebUtilSharedService, UtilModule } from '@scaliolabs/baza-web-utils';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { merge } from 'lodash';

import { AccountPaymentPayoutConfig } from '../../data-access';
import { PurchaseAccountPaymentComponent } from './payment/payment.component';
import { PurchaseAccountPayoutComponent } from './payout/payout.component';

@Component({
    selector: 'app-purchase-account',
    templateUrl: './account.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, UtilModule, PurchaseAccountPaymentComponent, PurchaseAccountPayoutComponent, NzEmptyModule, NzButtonModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PurchaseAccountComponent implements OnInit {
    @Input()
    dwollaSupport = true;

    @Input()
    initData: BazaNcBootstrapDto;

    @Input()
    config: AccountPaymentPayoutConfig;

    @Output()
    redirectToVFClicked = new EventEmitter<void>();

    i18nBasePath = 'dwacc.paymentAndPayout';
    @ContentChild('paymentMethodHeader') paymentMethodHeader: TemplateRef<any>;
    @ContentChild('payoutMethodHeader') payoutMethodHeader: TemplateRef<any>;

    constructor(public readonly wts: BazaWebUtilSharedService) {}

    ngOnInit(): void {
        this.checkConfig();
    }

    private checkConfig() {
        const defaultConfig: AccountPaymentPayoutConfig = {
            paymentMethodsConfig: {
                accountBalanceConfig: {
                    showAccountBalance: this.dwollaSupport ?? true,
                    enableTopup: this.dwollaSupport ?? true,
                },
                bankConfig: {
                    showBankAccount: true,
                    sectionHeader: null,
                },
                cardConfig: {
                    showCreditCard: true,
                    sectionHeader: null,
                },
            },
            payoutMethodsConfig: {
                showPayoutSection: true,
                isAnyAssetPurchased: false,
            },
        };

        this.config = merge(defaultConfig, this.config);
    }
}
